import React from 'react';

import { RouterProvider, createRouter } from '@tanstack/react-router';

import { patientRouteTree } from '@/router/PatientRouter.tsx';
import { practitionerRouteTree } from '@/router/PractitionerRouter.tsx';

export const patientRouter = createRouter({
  routeTree: patientRouteTree,
});

export const PatientRouter: React.FC = () => (
  <RouterProvider router={patientRouter} />
);

export const practitionerRouter = createRouter({
  routeTree: practitionerRouteTree,
});

export const PractitionerRouter: React.FC = () => (
  <RouterProvider router={practitionerRouter} />
);

export type PatientRouter = typeof patientRouter;
export type PractitionerRouter = typeof practitionerRouter;
